import { render, staticRenderFns } from "./AfiliadoForm.vue?vue&type=template&id=7f0cfb0b&scoped=true&"
import script from "./AfiliadoForm.vue?vue&type=script&lang=js&"
export * from "./AfiliadoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0cfb0b",
  null
  
)

export default component.exports